import { User } from "#sitis/internal/controllers/user/models/User";
import { UserOrder } from "#sitis/internal/controllers/user/models/UserOrder";
import { UserTransaction } from "#sitis/internal/controllers/user/models/UserTransaction";
import { UserAddress } from "#sitis/internal/controllers/user/models/UserAddress";
export class UserUseCase {
  agent;
  constructor(agent) {
    this.agent = agent;
  }
  // registration
  async signUp(body) {
    const response = await this.agent.post("/users/signup", {
      body: { ...body }
    }).catch((err) => {
      throw err;
    });
    if (response._data) {
      return true;
    }
  }
  // login
  async signIn(body) {
    const response = await this.agent.post("/users/login", {
      body: { ...body }
    }).catch((err) => {
      throw err.response;
    });
    if (response._data) {
      this.agent.auth({ authToken: response._data.token });
    }
    return response._data;
  }
  async getUser(expanded) {
    let query = "";
    if (expanded) {
      query = "?expand=group";
    }
    const response = await this.agent.get(`/users/me${query}`);
    if (response && response._data) {
      return new User(response._data).toJSON();
    }
    return;
  }
  async updateUser(body) {
    const response = await this.agent.put("/users/me", {
      body: { ...body }
    }).catch((err) => {
      throw err.response;
    });
    if (response && response._data) {
      return new User(response._data).toJSON();
    }
    return;
  }
  /* В поле username вводится email или номер телефона. В случае использования one-time passwords будет сгенерирован и
              * отправлен новый пароль (4 цифры) на номер телефона или email пользователя. Затем, номер телефона и пришедшую
              *  смс можно использовать в методе login. В случае постоянного пароля метод сгенерирует код (или ссылку для email)
              * для восстановления пароля, который необходимо использовать в методе api/users/reset/confirm.
              * Если используется капча, то в запросе должен быть параметр g-recaptcha-response с кодом от reCaptcha.
              */
  async requestPassword(body) {
    const response = await this.agent.post("/users/request", {
      body: { ...body }
    }).catch((err) => {
      throw err.response;
    });
    return response._data;
  }
  async confirmPhone(body) {
    const response = await this.agent.post("/users/confirm/phone", {
      body: { ...body }
    }).catch((err) => {
      throw err.response;
    });
    return response._data;
  }
  async getOrders(queryParams) {
    const response = await this.agent.get("/users/orders", {
      query: {
        ...queryParams
      }
    }).then((res) => res).catch((err) => {
      throw err.response;
    });
    if (response && response._data) {
      const _data = response._data.map((t) => new UserOrder(t).toJSON());
      return {
        _data,
        headers: response.headers
      };
    }
  }
  async getTransactions(queryParams) {
    const response = await this.agent.get("/users/transactions", {
      query: { ...queryParams }
    }).then((res) => res).catch((err) => {
      throw err.response;
    });
    if (response && response._data) {
      const _data = response._data.map((t) => new UserTransaction(t).toJSON());
      return {
        _data,
        headers: response.headers
      };
    }
  }
  async getAddress() {
    const response = await this.agent.get("user/addresses").then((res) => res).catch((err) => {
      throw err.response;
    });
    if (response._data) {
      const _data = response._data.map((t) => new UserAddress(t).toJSON());
      return {
        _data,
        headers: response.headers
      };
    }
  }
  async createAddress(data) {
    const addressBody = UserAddress.toBackendFormat(data);
    const response = await this.agent.post("user/addresses", { body: { ...addressBody } }).then((res) => res).catch((err) => {
      throw err;
    });
    if (response._data) {
      const _data = new UserAddress(response._data).toJSON();
      return {
        _data,
        headers: response.headers
      };
    }
  }
  async editAddress(addressesId, data) {
    const addressBody = UserAddress.toBackendFormat(data);
    const response = await this.agent.put(`user/addresses/${addressesId}`, { body: { ...addressBody } }).then((res) => res).catch((err) => {
      throw err;
    });
    if (response._data) {
      const _data = new UserAddress(response._data).toJSON();
      return {
        _data,
        headers: response.headers
      };
    }
  }
}
